import React, { useContext, useState } from 'react'
import axios from 'axios'
import { Link, useHistory } from 'react-router-dom';
import './AuthForm.scss'
import UserContext from '../../context/UserContext';
import ErrorMessage from '../misc/ErrorMessage';
import domain from '../../util/domain';

function Login() {
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [errorMessage, setErrorMessage] = useState(null);
    const history = useHistory()
    const { getUser } = useContext(UserContext)

    async function login(e) {
        e.preventDefault();
        const loginData = { email, password }
        try {
        await axios.post(`${domain}/auth/login`, loginData)
        console.log(loginData)
        } catch(err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return
        }
        await getUser()
        history.push('/')
    }

    return (
        <div className="auth-form">
            <h2>Log in</h2>
            {errorMessage && <ErrorMessage message={errorMessage} clear={() => setErrorMessage(null)}/>}
            <form className="form" onSubmit={login}>
                <label htmlFor="email">Email</label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                <label htmlFor="password">Password</label>
                <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <button className="btn-submit-auth" type="submit">Log in</button>
            </form>
            <p>Don't have an account? <Link to='/register'>Register here.</Link></p>
        </div>
    )
}

export default Login
